import { DesignAssets } from '../types/questionnaire';

// 画像をインポート（Viteで正しくバンドルされるように）
import logoImage from '../assets/images/logo.svg';
import topImage from '../assets/images/top_img.svg';
import thanksImage from '../assets/images/thanks_img.svg';
import questionImage from '../assets/images/question_img.svg';

// GB人材デザインアセットの定義
export const gbDesignAssets: DesignAssets = {
  images: {
    logo: logoImage,
    topImage: topImage,
    thanksImage: thanksImage,
    questionImage: questionImage,
  },
  icons: {
    // アイコンは必要に応じてインポートに変更
    home: '/assets/icons/icon_home.svg',
    phone: '/assets/icons/icon_phone.svg',
    passwordEye: '/assets/icons/icon_password_eye.svg',
    passwordEyeClose: '/assets/icons/icon_password_eye_close.svg',
    individualDiagnosisResult: '/assets/icons/icon_individual_diagnosis_result.svg',
    organizationDiagnosisResult: '/assets/icons/icon_organization_diagnosis_result.svg',
    yourDiagnosisResult: '/assets/icons/icon_your_diagnosis_result.svg',
  },
  colors: {
    primary: '#0068B7',
    base: '#666464',
    placeholder: 'rgba(92,92,92, .4)',
    gradientPrimary: 'linear-gradient(135deg, #0068B7 0%, #004A8C 100%)',
    gradientSecondary: 'linear-gradient(135deg, #0068B7 0%, #0080E6 100%)',
    gradientProgress: 'linear-gradient(90deg, #0068B7 0%, #00A3FF 100%)',
  },
  fonts: {
    base: 'Noto Sans JP',
    english: 'Poppins',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
  },
  borderRadius: {
    small: '0.25rem',
    medium: '0.5rem',
    large: '1rem',
    xlarge: '1.5rem',
    infinity: '9999px',
  },
  shadows: {
    small: '0 1px 3px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 6px rgba(0, 0, 0, 0.1)',
    large: '0 10px 15px rgba(0, 0, 0, 0.1)',
    gbCard: '0 4px 20px rgba(0, 104, 183, 0.15)',
  },
  transitions: {
    base: '0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    fast: '0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '0.6s cubic-bezier(0.4, 0, 0.2, 1)',
  },
};

// CSS変数を動的に設定するヘルパー関数
export const setProgressBarVariables = (current: number, total: number): void => {
  const root = document.documentElement;
  root.style.setProperty('--_question-num-current', current.toString());
  root.style.setProperty('--_question-num-total', total.toString());
};

// GB人材ブランドカラーをCSS変数として設定
export const applyGBBrandColors = (): void => {
  const root = document.documentElement;
  root.style.setProperty('--color-blue', gbDesignAssets.colors.primary);
  root.style.setProperty('--color-base', gbDesignAssets.colors.base);
  root.style.setProperty('--color-placeholder', gbDesignAssets.colors.placeholder);
};

// Noto Sans JPフォントの読み込み確認
export const ensureGBFontsLoaded = (): Promise<void> => {
  return new Promise((resolve) => {
    if (document.fonts) {
      document.fonts.ready.then(() => {
        resolve();
      });
    } else {
      // フォールバック: 少し待ってから解決
      setTimeout(resolve, 100);
    }
  });
};

// デザインアセットのプリロード（画像のみ、アイコンは使用時に読み込み）
// 注意: link preloadは使用直前に行わないとブラウザ警告が出るため、
// 実際の画像読み込みはコンポーネント内で行う
export const preloadGBAssets = (): void => {
  // プリロードは無効化 - 画像は使用時にコンポーネント内で読み込む
  // これにより「preloaded but not used」警告を防ぐ
  // 
  // 以前の実装:
  // const imagesToPreload = Object.values(gbDesignAssets.images);
  // imagesToPreload.forEach((src) => {
  //   const link = document.createElement('link');
  //   link.rel = 'preload';
  //   link.as = 'image';
  //   link.href = src;
  //   document.head.appendChild(link);
  // });
};